module.exports = __webpack_public_path__ + "images/emoji/repeat.8cd235779f576eb5bdc4.png";